module.exports = __webpack_public_path__ + "static/media/speedrace-mockup.c7136804.png";